import { useCallback } from 'react'

export const useSanitizeDocxHtml = () => {
  return useCallback((html: string): string => {
    if (!html) return ''

    let cleaned = html

    // Remove "Top of Form" / "Bottom of Form" artifacts
    cleaned = cleaned.replace(/<p[^>]*>\s*Top of Form\s*<\/p>/gi, '')
    cleaned = cleaned.replace(/<p[^>]*>\s*Bottom of Form\s*<\/p>/gi, '')
    cleaned = cleaned.replace(/>Top of Form</gi, '><')
    cleaned = cleaned.replace(/>Bottom of Form</gi, '><')

    // Remove "Welcome" placeholder content
    cleaned = cleaned.replace(/<p[^>]*>\s*Welcome,\s*[^<]*<\/p>/gi, '')

    // Remove form elements
    cleaned = cleaned.replace(/<input[^>]*>/gi, '')
    cleaned = cleaned.replace(/<select[^>]*>[\s\S]*?<\/select>/gi, '')
    cleaned = cleaned.replace(/<button[^>]*>[\s\S]*?<\/button>/gi, '')
    cleaned = cleaned.replace(/<form[^>]*>[\s\S]*?<\/form>/gi, '')
    cleaned = cleaned.replace(/<textarea[^>]*>[\s\S]*?<\/textarea>/gi, '')

    // Remove empty paragraphs and excessive whitespace
    cleaned = cleaned.replace(/(<p[^>]*>)\s*(<\/p>)/gi, '')
    cleaned = cleaned.replace(/\n{3,}/g, '\n\n')

    return cleaned.trim()
  }, [])
}
